<template>
  <Loading v-if="loading" />
  <div v-else-if="invoiceItems">
    <CollapsableContent
      v-if="billInvoiceItems.length > 0"
      :title="`Facturé à ${invoice.entityName}`"
      :subtitle="`Total dû à Estaly : ${formatPrice(billAmount)}`"
    >
      <Table :columns="invoiceColumns" :data="formattedBillItems" />
    </CollapsableContent>

    <CollapsableContent
      v-if="statementInvoiceItems.length > 0"
      class="mt-4"
      :title="`Versé à ${invoice.entityName}`"
      :subtitle="`Total dû à ${invoice.entityName} : ${formatPrice(statementAmount)}`"
    >
      <Table :columns="invoiceColumns" :data="formattedStatementItems" />
    </CollapsableContent>
  </div>
</template>
<script>
import { CollapsableContent, Loading, Table, formatPrice } from "@estaly/ui";
import InvoicesService from "@/api/services/invoices";

export default {
  components: {
    CollapsableContent,
    Loading,
    Table,
  },
  data() {
    return {
      invoiceItems: null,
      statementAmount: null,
      billAmount: null,
      loading: true,
    };
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    invoiceColumns() {
      return [
        { label: this.$t("Customer"), field: "customer" },
        { label: this.$t("Reference"), field: "planSaleId" },
        { label: this.$t("Nature"), field: "nature" },
        { label: this.$t("Date"), field: "date" },
        { label: this.$t("Premium TTC"), field: "price", price: true },
        { label: this.$t("Commission"), field: "storeCommissionAmount", price: true },
        { label: this.$t("Amount owed"), field: "amount", price: true },
      ];
    },
    filteredInvoiceItems() {
      return this.invoiceItems.filter((item) => item.storeCommissionAmount > 0);
    },
    statementInvoiceItems() {
      return this.filteredInvoiceItems.filter((item) => item.transactionType === "statement");
    },
    billInvoiceItems() {
      return this.filteredInvoiceItems.filter((item) => item.transactionType === "bill");
    },
    formattedBillItems() {
      return this.formatItems(this.billInvoiceItems);
    },
    formattedStatementItems() {
      return this.formatItems(this.statementInvoiceItems);
    },
  },
  mounted() {
    this.getInvoiceItems();
  },
  methods: {
    formatPrice,
    formatItems(items) {
      return items.map((item) => ({
        customer: item.customer,
        planSaleId: item.planSaleId,
        nature: item.billingType === "collected" ? this.$t("subscription") : this.$t("termination"),
        date: item.date,
        price: item.price,
        storeCommissionAmount: item.storeCommissionAmount,
        amount: item.amount,
      }));
    },
    async getInvoiceItems() {
      const response = await InvoicesService.fetchItems(this.invoice.id);
      if (!response?.success) return;

      this.invoiceItems = response.data.invoiceItems;
      this.statementAmount = response.data.statementAmount;
      this.billAmount = response.data.billAmount;
      this.loading = false;
    },
  },
};
</script>
